import * as api from '../api';

export const getSiteActions = api.fetchActions('demographics', 'get-site');
export const getFormActions = api.fetchActions('demographics', 'get-form');
export const getFormAnswersActions = api.fetchActions('demographics', 'get-answers');
export const getSettingsActions = api.fetchActions('demographics', 'get-settings');
export const updateDemographicsActions = api.fetchActions('demographics', 'update-demographics');
export const fetchAttachmentActions = api.fetchActions('demographics', 'fetch-attachment');

export const actionTypes = {
  ...getSiteActions.actionTypes,
  ...getFormActions.actionTypes,
  ...getFormAnswersActions.actionTypes,
  ...getSettingsActions.actionTypes,
  ...updateDemographicsActions.actionTypes,
  ...fetchAttachmentActions.actionTypes,
  CLEAR_DEMOGRAPHICS_ANSWERS: 'demographics.clear-demographics-answers'
};

export const getSite = () => api.getThunk(`/demographics/get-site`, null, getSiteActions);
export const getForm = (siteId) => api.getThunk(`/demographics/get-form`, {siteId}, getFormActions);
export const getFormAnswers = (siteId) => api.getThunk(`/demographics/get-answers`, {siteId}, getFormAnswersActions);
export const getSettings = () => api.getThunk(`/demographics-permissions/settings`, null, getSettingsActions);
export const updateDemographics = (siteId, answers) => api.postThunk(`/demographics/update-answers`, {Site: siteId, Answers: answers}, updateDemographicsActions);
export const fetchAttachment = (fileId) => api.getStreamThunk(`/demographics/attachment?id=${fileId}`, null, fetchAttachmentActions, {id: fileId});

export function clearDemographicsAnswers(){
  return {
    type: actionTypes.CLEAR_DEMOGRAPHICS_ANSWERS
  }
}




// WEBPACK FOOTER //
// src/demographics/demographics.actions.js